import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Trophy, Users, Calendar, Coins, ArrowRight } from "lucide-react";
import api from "@/lib/api";
import { PageHero } from "@/components/Shared";

export default function SeasonArchive() {
  const [seasons, setSeasons] = useState([]);

  useEffect(() => {
    api.get("/seasons").then((r) => setSeasons(r.data)).catch(() => {});
  }, []);

  return (
    <div data-testid="season-archive-page">
      <PageHero
        title="Season Archive"
        subtitle="Look back at past Legends seasons — the champions crowned and the standings that decided them."
        image="https://images.unsplash.com/photo-1706193589333-da530df63ecf?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600"
        testId="season-archive-hero"
      />
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-16 md:py-24">
        {seasons.length === 0 ? (
          <p className="text-slate-400 text-center py-20">No seasons recorded yet.</p>
        ) : (
          <div className="grid md:grid-cols-2 gap-8">
            {seasons.map((s, i) => (
              <div key={s.season} className="bg-navy-paper border border-slate-800 hover:border-gold/50 transition-all duration-300 hover:-translate-y-1 p-8 animate-fade-up" style={{ animationDelay: `${i * 90}ms` }} data-testid={`season-card-${i}`}>
                <div className="flex items-start justify-between">
                  <div>
                    <div className="text-gold text-xs uppercase tracking-[0.3em] mb-2">Season</div>
                    <h3 className="font-display text-2xl font-bold text-white">{s.season}</h3>
                  </div>
                  <Trophy className="w-8 h-8 text-gold" />
                </div>

                <div className="mt-6 bg-navy border border-gold/20 p-5">
                  <div className="text-slate-500 text-[10px] uppercase tracking-widest mb-1">Champion</div>
                  <div className="font-display text-xl font-bold text-gold">{s.champion || "TBD"}</div>
                  <div className="text-slate-400 text-sm mt-1">{s.champion_points} points</div>
                </div>

                <div className="grid grid-cols-3 gap-3 mt-6">
                  {[
                    { icon: Users, label: "Players", value: s.players },
                    { icon: Calendar, label: "Events", value: s.events },
                    { icon: Coins, label: "Paid Out", value: `$${(s.total_payout || 0).toLocaleString()}` },
                  ].map((st, k) => (
                    <div key={st.label} className="text-center">
                      <st.icon className="w-4 h-4 text-gold mx-auto mb-1.5" />
                      <div className="text-white font-semibold text-sm">{st.value}</div>
                      <div className="text-slate-500 text-[10px] uppercase tracking-widest">{st.label}</div>
                    </div>
                  ))}
                </div>

                <Link to={`/leaderboards?season=${encodeURIComponent(s.season)}`} className="mt-6 inline-flex items-center gap-2 text-gold hover:gap-3 transition-all text-sm uppercase tracking-widest" data-testid={`season-standings-${i}`}>
                  Final Standings <ArrowRight className="w-4 h-4" />
                </Link>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
